// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","footnote":"footnote_footnote__o3u8C"};